import { IApplicationConfiguration } from '../../interfaces/scheduler_interfaces';
import { TransientAccessCredModel } from '../models/transient_access_cred_model';
import { ITransientAccessCred } from '../builders/transient_access_cred_builder';
import { IQuery } from 'core-ts-types';
import { Query } from 'utility-ts-orm';
import * as _4 from 'lodash4';
import { TransientAccessCredWorkflowModel } from '../models/transient_access_cred_workflow_model';

export interface IPreventTransientAccessQueryResult {
  workflowEnabled: boolean;
  output?: {
    student_credentials: ITransientAccessCred;
  };
  redirectToAuthWorkflow: boolean;
}

export class PreventTransientAccessQuery implements IQuery {
  constructor(
    private ngTransientAccessCredModel: TransientAccessCredModel,
    private ngTransientAccessCredWorkflowModel: TransientAccessCredWorkflowModel,
    private appConfigModel: IApplicationConfiguration
  ) {
    Query.registerQuery(this, ngTransientAccessCredModel, ngTransientAccessCredWorkflowModel);
  }

  get result(): IPreventTransientAccessQueryResult {
    const workflowTempEnabled = this.ngTransientAccessCredWorkflowModel.read().enabled;
    const preventTransientAccessFeatureEnabled = this.appConfigModel.isFeatureEnabled('reg-scheduler_user_credentials');
    const preventTransientAccessEnabled = workflowTempEnabled && preventTransientAccessFeatureEnabled;
    if (preventTransientAccessEnabled) {
      const studentCred = this.ngTransientAccessCredModel.read();
      const isEmpty = _4.isEmpty(studentCred.password) || _4.isEmpty(studentCred.username);
      return {
        workflowEnabled: true,
        output: {
          student_credentials: studentCred
        },
        redirectToAuthWorkflow: isEmpty
      };
    }
    return {
      workflowEnabled: false,
      output: undefined,
      redirectToAuthWorkflow: false
    };
  }

  run() {
    return this;
  }
}

angular.module('capability-ng-scheduler').service('ngPreventTransientAccessQuery', PreventTransientAccessQuery);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/prevent_transient_access/queries/prevent_transient_access_query.ts